import { render, staticRenderFns } from "./ScannerComponent.vue?vue&type=template&id=47018da8&scoped=true&"
import script from "./ScannerComponent.vue?vue&type=script&lang=js&"
export * from "./ScannerComponent.vue?vue&type=script&lang=js&"
import style0 from "./ScannerComponent.vue?vue&type=style&index=0&id=47018da8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47018da8",
  null
  
)

export default component.exports